import "@hotwired/turbo-rails"
import $ from "jquery"
import { Foundation } from "foundation-sites"

import "./concepts/lol_champion/champion_select"
import "./concepts/shared/star-rating"

window.jQuery = window.$ = $

document.addEventListener("turbo:load", () => $(document).foundation())
